import newOwnersDetailsSaga from './sagas'
import slice from './reducer'

export const {
  fetchDetailsRequest: newOwnersDetailRequest,
  fetchDetailsSuccess: newOwnersDetailSuccess,
  fetchDetailsError: newOwnersDetailError,

  updateStatusRequest: newOwnerUpdateStatusRequest,
  updateStatusSuccess: newOwnerUpdateStatusSuccess,
  updateStatusError: newOwnerUpdateStatusError,
} = slice.actions

export default slice.reducer
export { newOwnersDetailsSaga }
